import { validations } from './validations';
import { helpers } from './helpers';
// import distritos from '../../../assets/portugal-distritos.json';

const distritos = [];

export const forms = {
    taxa_esforco: {
        validation: validations.taxa_esforco,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/effort-rate',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            processType: 4,
            operationType: 2,
        },
        fields: [
            {
                type: 'title',
                label: 'Rendimento mensal',
            },
            {
                type: 'heading',
                label: 'Rendimento mensal',
            },
            {
                type: 'number',
                label: 'Rendimento Mensal Líquido',
                name: 'net_monthly_income',
                icon: 'currency',
                tooltip: {
                    title: 'Rendimento Mensal Líquido',
                    content: 'Total de rendimentos líquidos, ou seja, valores deduzidos de todos os descontos obrigatórios (IRS, Segurança Social, etc.). Inclui salário e outros rendimentos regulares como rendas ou pensões.',
                    placement: 'right',
                },
            },
            {
                type: 'heading',
                label: 'Despesas mensais',
            },
            {
                type: 'number',
                label: 'Crédito Habitação',
                name: 'mortgage',
                icon: 'currency',
                tooltip: {
                    title: 'Crédito Habitação',
                    content: 'Valor da prestação mensal do crédito habitação.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Crédito automóvel',
                name: 'car_loan',
                icon: 'currency',
                tooltip: {
                    title: 'Crédito automóvel',
                    content: 'Valor da prestação mensal do crédito automóvel.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Crédito pessoal',
                name: 'personal_loan',
                icon: 'currency',
                tooltip: {
                    title: 'Crédito pessoal',
                    content: 'Valor da prestação mensal do crédito pessoal.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Dívida do cartão de crédito',
                name: 'credit_card_debt',
                icon: 'currency',
                tooltip: {
                    title: 'Dívida do cartão de crédito',
                    content: 'Valor da dívida do cartão de crédito.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Outros créditos',
                name: 'other_loans',
                icon: 'currency',
                tooltip: {
                    title: 'Outros créditos',
                    content: 'Valor da prestação mensal de outros créditos.',
                    placement: 'right',
                },
            },
            /*{
                type: 'number',
                label: 'Total de encargos domésticos',
                name: 'total_domestic_burdens',
                icon: 'currency',
                tooltip: {
                    title: 'Total de encargos domésticos',
                    content: 'Valor total de encargos domésticos.',
                    placement: 'right',
                },
            },*/
            /*{
                type: 'heading',
                label: 'Seguros',
            },
            {
                type: 'number',
                label: 'Seguro de Vida',
                name: 'life_insurance',
                icon: 'currency',
                tooltip: {
                    title: 'Seguro de Vida',
                    content: 'Valor da prestação mensal do seguro de vida.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Seguro multiriscos',
                name: 'multi_risk_insurance',
                icon: 'currency',
                tooltip: {
                    title: 'Seguro multiriscos',
                    content: 'Valor da prestação mensal do seguro multiriscos.',
                    placement: 'right',
                },
            },*/
        ],
    },
    salario_liquido: {
        validation: validations.salario_liquido,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/salario-liquido',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            processType: 4,
            operationType: 2,
        },
        fields: [
            {
                type: 'title',
                label: 'Dados do agregado familiar',
            },
            {
                type: 'select',
                options: helpers.locations(),
                label: 'Localização',
                name: 'localizacao',
                defaultValue: 'CNT',
                tooltip: {
                    title: 'Localização',
                    content: 'Localização...',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: [
                    { value: 'SOL', label: 'Não casado' },
                    { value: 'CAS1', label: 'Casado, 1 titular' },
                    { value: 'CAS2', label: 'Casado, 2 titulares' },
                ],
                label: 'Situação',
                name: 'situacao',
                defaultValue: 'CAS1',
            },
            {
                type: 'number',
                label: 'Nº de dependentes',
                name: 'n_de_dependentes',
                defaultValue: 0,
            },
            {
                type: 'heading',
                label: 'Incapacidade',
            },
            {
                type: 'checkbox',
                label: 'Tenho incapacidade superior a 60%',
                name: 'incapacidade_superior_a_60%',
            },
            {
                type: 'checkbox',
                label: 'O meu cônjuge tem incapacidade superior a 60%',
                name: 'conjuge_tem_deficiencia',
            },
            {
                type: 'checkbox',
                label: 'Um ou mais dos meus dependentes tem incapacidade superior a 60%',
                name: 'dependentes_tem_deficiencia',
            },
            {
                type: 'number',
                label: 'Nº de dependentes com incapacidade',
                name: 'n_de_dependentes_com_deficiência',
                condition: [
                    {
                        field: 'dependentes_tem_deficiencia',
                        value: true,
                    },
                ],
            },
            {
                type: 'title',
                label: 'Rendimento mensal',
            },
            {
                type: 'number',
                label: 'Rendimento base',
                name: 'vencimento_base',
                icon: 'currency',
                defaultValue: 0,
            },
            {
                type: 'number',
                label: 'Retribuição extraordinária',
                name: 'retribuicao_extraordinaria',
                icon: 'currency',
                defaultValue: 0,
            },
            {
                type: 'number',
                label: 'Rendimentos isentos',
                name: 'outros_rendimentos_isentos',
                icon: 'currency',
                defaultValue: 0,
            },
            {
                type: 'number',
                label: 'suj. a IRS e SS',
                name: 'outros_rendimentos_irs_ss',
                icon: 'currency',
                defaultValue: 0,
            },
            {
                type: 'number',
                label: 'suj. só IRS',
                name: 'outros_rendimentos_irs',
                icon: 'currency',
                defaultValue: 0,
            },
            {
                type: 'number',
                label: 'Taxa de Segurança Social',
                name: 'taxa_de_seguranca_social',
                icon: 'percentage',
                defaultValue: 11,
            },
            {
                type: 'heading',
                label: 'Recebe subsídio(s) em duodécimos?',
            },
            {
                type: 'select',
                options: [
                    { value: 'nao_recebo', label: 'Não recebo os subsídios em duodécimos' },
                    { value: 'recebo_50_1', label: 'Recebo 50% de um subsídio em duodécimos' },
                    { value: 'recebo_50_2', label: 'Recebo 50% dos dois subsídios ou 1 subsídio completo em duodécimos' },
                    { value: 'recebo_2', label: 'Recebo os dois subsídios por inteiro em duodécimos' },
                ],
                name: 'duodecimos',
            },
            {
                type: 'heading',
                label: 'Recebe subsídio de alimentação?',
            },
            {
                type: 'select',
                options: [
                    { value: 'nao_tenho', label: 'Não tenho' },
                    { value: 'cartao', label: 'Cartão/Vales refeição' },
                    { value: 'remuneracao', label: 'Remuneração' },
                ],
                name: 'cartao_refeicao_tipo',
            },
            {
                type: 'number',
                label: 'Valor diário',
                name: 'cartao_refeicao_valor_diario',
                icon: 'currency',
                defaultValue: 9.6,
                condition: [
                    {
                        field: 'cartao_refeicao_tipo',
                        value: 'cartao',
                    },
                    {
                        field: 'cartao_refeicao_tipo',
                        value: 'remuneracao',
                    },
                ],
            },
            {
                type: 'number',
                label: 'Dias',
                name: 'cartao_refeicao_dias',
                defaultValue: 22,
                condition: [
                    {
                        field: 'cartao_refeicao_tipo',
                        value: 'cartao',
                    },
                    {
                        field: 'cartao_refeicao_tipo',
                        value: 'remuneracao',
                    },
                ],
            },
        ],
    },
    transferencia_credito: {
        validation: validations.taxa_esforco,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/transferencia-credito',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'heading',
                label: 'Crédito atual',
            },
            {
                type: 'number',
                label: 'Capital em dívida',
                name: 'rendimento_mensal_liquido',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Taxa de juro (spread+euribor)',
                name: 'credito_habitacao',
                icon: 'percentage',
                tooltip: {
                    title: 'Taxa...',
                    content: '....',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Prestações a pagar',
                name: 'prestacao_pagar',
            },
            {
                type: 'heading',
                label: 'Novo crédito',
            },
            {
                type: 'number',
                label: 'Capital em dívida',
                name: 'capital_divida',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Taxa de juro (spread+euribor)',
                name: 'taxa_juro',
                icon: 'percentage',
            },
            {
                type: 'number',
                label: 'Prestações a pagar',
                name: 'prestacao_pagar',
            },
        ],
    },
    pretacao_credito_habitacao: {
        validation: validations.prestacao_credito_habitacao,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/prestacao-credito-habitacao',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'number',
                label: 'Capital em dívida',
                name: 'capital_divida',
                icon: 'currency',
                tooltip: {
                    title: '...',
                    content: '....',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Taxa de juro (spread+euribor)',
                name: 'taxa_juro',
                icon: 'percentage',
                tooltip: {
                    title: 'Taxa...',
                    content: '....',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Prestações a pagar',
                name: 'prestacao_pagar',
                tooltip: {
                    title: '...',
                    content: '....',
                    placement: 'right',
                },
            },
        ],
    },
    variacao_euribor: {
        validation: validations.variacao_euribor,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/variacao-euribor',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'number',
                label: 'Capital em dívida',
                name: 'capital_divida',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Taxa de juro (spread+euribor)',
                name: 'taxa_juro',
                icon: 'percentage',
            },

            {
                type: 'number',
                label: 'Prestações a pagar',
                name: 'prestacao_pagar',
            },
            {
                type: 'date',
                label: 'Última alteração de prestação',
                name: 'ultima_alteracao_prestacao',
            },
            {
                type: 'date',
                label: '1ª prestação após revisão',
                name: 'primeira_prestacao',
            },
            {
                type: 'select',
                options: [
                    { value: '3_meses', label: '3 meses' },
                    { value: '6_meses', label: '6 meses' },
                    { value: '12_meses', label: '12 meses' },
                ],
                name: 'taxa_euribor',
                label: 'Taxa Euribor',
            },
            {
                type: 'checkbox',
                label: 'Simular variações na Euribor',
                name: 'simular_variacoes',
            },
            {
                type: 'number',
                label: 'Valor da Euribor',
                name: 'valor_euribor',
                condition: [
                    {
                        field: 'simular_variacoes',
                        value: true,
                    },
                ],
            },
        ],
    },
    subsidio_desemprego: {
        validation: validations.subsidio_desemprego,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/subsidio-desemprego',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados contributivos',
                name: 'title_dados_contributivos',
                collapsible: true,
            },
            {
                type: 'number',
                label: 'Idade',
                name: 'idade',
                tooltip: {
                    title: '...',
                    content: '....',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Carreira contributiva em meses',
                name: 'carreira_contributiva',
                tooltip: {
                    title: '...',
                    content: '....',
                    placement: 'right',
                },
            },
            {
                type: 'heading',
                label: 'Nos últimos 24 meses imediatamente anteriores ao desemprego, fez contribuições em 360 dias ou mais?',
            },
            {
                type: 'radio',
                label: '',
                name: 'contribuições',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'title',
                label: 'Situação laboral',
                name: 'title_situacao_laboral',
                collapsible: {
                    collapsed: true,
                },
            },
            {
                type: 'heading',
                label: 'Preencha os dados laborais tendo em conta os os primeiros 12 meses dos últimos 14 anteriores à situação de desemprego',
            },
            {
                type: 'number',
                label: 'Salário bruto médio',
                name: 'salario_bruto_medio',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Subsídio de férias',
                name: 'subsidio_ferias',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Subsídio de natal',
                name: 'subsidio_natal',
                icon: 'currency',
            },
            {
                type: 'select',
                options: Array(12).fill().map((_, index) => ({
                    value: index + 1,
                    label: index + 1,
                })),
                label: 'Meses com desconto',
                name: 'meses_desconto',
                tooltip: {
                    title: '...',
                    content: '...',
                    placement: 'right',
                },
            },
            {
                type: 'title',
                label: 'Enquadramento em IRS',
                name: 'title_enquadramento_irs',
                collapsible: {
                    collapsed: true,
                },
            },
            {
                type: 'select',
                options: [
                    { value: 'portugal_continental', label: 'Portugal Continental' },
                    { value: 'madeira', label: 'Região Autónoma da Madeira' },
                    { value: 'acores', label: 'Região Autónoma dos Açores' },
                ],
                label: 'Localização',
                name: 'localizacao',
                tooltip: {
                    title: 'Localização',
                    content: 'Localização...',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: [
                    { value: 'nao_casado', label: 'Não casado' },
                    { value: 'casado_1', label: 'Casado, 1 titular' },
                    { value: 'casado_2', label: 'Casado, 2 titulares' },
                ],
                label: 'Situação',
                name: 'situacao',
            },
            {
                type: 'number',
                label: 'Nº de dependentes',
                name: 'dependentes',
            },
            {
                type: 'select',
                options: [
                    { value: 'monoparental', label: 'Família monoparental, com Abono de Família pelos filhos' },
                    { value: '2_conjuges', label: 'Dois cônjuges, ambos a receber Subsídio de Desemprego e com Abono de Família pelos filhos' },
                    { value: 'outra', label: 'Outra' },
                ],
                label: 'Situação familiar',
                name: 'situacao_familiar',
            },
        ],
    },
    trabalhadores_independentes: {
        validation: validations.trabalhadores_independentes,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/trabalhadores-independentes',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'heading',
                label: 'Atividade',
            },
            {
                type: 'select',
                options: [
                    { value: 'trabalhador_independente', label: 'Trabalhador Independente' },
                    { value: 'eni', label: 'Empresário em nome individual' },
                ],
                label: 'Trabalhador',
                name: 'trabalhador',
            },
            {
                type: 'select',
                options: [
                    { value: 'simplificado', label: 'Simplificado' },
                    { value: 'contabilidade_organizada', label: 'Contabilidade Organizada' },
                ],
                label: 'Regime',
                name: 'regime',
            },
            {
                type: 'checkbox',
                label: 'Cônjuge de trabalhador independente',
                name: 'conjuge_trabalhador_independente',
            },
            {
                type: 'select',
                options: [
                    { value: 'simplificado', label: 'Sem isenção' },
                    { value: 'trab_conta_outrem', label: 'Trab. por conta de outrem' },
                    { value: 'pensionista', label: 'Pensionista' },
                    { value: 'incapacidade', label: 'Incapacidade' },
                    { value: 'baixos_rendimentos', label: 'Baixos rendimentos' },
                ],
                label: 'Isenções',
                name: 'isencoes',
            },
            {
                type: 'heading',
                label: 'Rendimento trimestral',
            },
            {
                type: 'number',
                label: 'Prestações de serviços',
                name: 'prestacoes_servicos',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Vendas',
                name: 'vendas',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Atividades hoteleiras, restauração e similares',
                name: 'actividades_hoteleiras',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Subsídios à exploração',
                name: 'subsidios_exploracao',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Outros rendimentos',
                name: 'outros_rendimentos',
                icon: 'currency',
            },
        ],
    },
    pensao_liquida: {
        validation: validations.pensao_liquida,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/pensao-liquida',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            processType: 4,
            operationType: 2,
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'select',
                options: [
                    { value: 'portugal_continental', label: 'Portugal Continental' },
                    { value: 'madeira', label: 'Região Autónoma da Madeira' },
                    { value: 'acores', label: 'Região Autónoma dos Açores' },
                ],
                label: 'Localização',
                name: 'localizacao',
                tooltip: {
                    title: 'Localização',
                    content: 'Localização...',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: [
                    { value: 'nao_casado', label: 'Não casado' },
                    { value: 'casado_1', label: 'Casado, 1 titular' },
                    { value: 'casado_2', label: 'Casado, 2 titulares' },
                ],
                label: 'Situação',
                name: 'situacao',
            },
            {
                type: 'select',
                options: [
                    { value: 'geral', label: 'Geral' },
                    { value: 'deficiente', label: 'Deficiente' },
                    { value: 'deficiente_forcas_armadas', label: 'Deficiente das Forças Armadas' },
                ],
                label: 'Tipo de pensão',
                name: 'tipo_pensao',
            },
            {
                type: 'number',
                label: 'Valor bruto da pensão',
                name: 'valor_bruto_pensao',
                icon: 'currency',
            },
            {
                type: 'heading',
                label: 'Tem dependentes?',
            },
            {
                type: 'radio',
                label: '',
                name: 'dependentes',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'number',
                label: 'Nº de dependentes',
                name: 'nr_dependentes',
                condition: [
                    {
                        field: 'dependentes',
                        value: 'sim',
                    },
                ],
            },
            {
                type: 'number',
                label: 'Nº de dependentes com deficiências',
                name: 'dependentes_deficiencia',
                condition: [
                    {
                        field: 'dependentes',
                        value: 'sim',
                    },
                ],
            },
        ],
    },
    mais_valias: {
        validation: validations.mais_valias,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/mais-valias',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Cálculo da mais-valia',
                collapsible: true,
                name: 'title_calculo_mais_valia',
            },
            {
                type: 'heading',
                label: 'Tipologia de Aquisição',
            },
            {
                type: 'select',
                options: [
                    { value: 'oneroso', label: 'Oneroso (compra ou permuta)' },
                ],
                label: 'Título',
                name: 'titulo',
                tooltip: {
                    title: '...',
                    content: '...',
                    placement: 'right',
                },
            },
            {
                type: 'heading',
                label: 'Valor de Aquisição',
            },
            {
                type: 'number',
                label: 'Escritura',
                name: 'escritura',
                icon: 'currency',
            },
            {
                type: 'select',
                options: helpers.generateYears(),
                label: 'Ano',
                name: 'ano',
                half: true,
                tooltip: {
                    title: '...',
                    content: '...',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: helpers.generateMonths(),
                label: 'Mês',
                name: 'mes',
                half: true,
                tooltip: {
                    title: '...',
                    content: '...',
                    placement: 'right',
                },
            },
            {
                type: 'heading',
                label: 'Teve despesas e encargos (obras, IMT, Imposto de selo, outros)?',
            },
            {
                type: 'radio',
                label: '',
                name: 'contribuições',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Despesas e encargos',
            },
            {
                type: 'number',
                label: 'Obras e melhorias',
                name: 'obras_melhorias',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'IMT',
                name: 'imt',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Imposto de Selo',
                name: 'imposto_selo',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Comissão Imobiliária',
                name: 'comissao_imobiliaria',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Certificado Energético',
                name: 'certificado_energetico',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Outros',
                name: 'outros',
                icon: 'currency',
            },
            {
                type: 'title',
                label: 'Cálculo do imposto a pagar em sede de IRS',
                collapsible: {
                    collapsed: true,
                },
                name: 'title_calculo_imposto_irs',
            },
            {
                type: 'heading',
                label: 'O imóvel era a sua habitação própria e permanente (HPP) ou do seu agregado familiar?',
            },
            {
                type: 'radio',
                label: '',
                name: 'habitação_permanente',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Está reformado ou tem mais de 65 anos?',
            },
            {
                type: 'radio',
                label: '',
                name: 'reformado',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Pretende reinvestir o dinheiro noutra HPP?',
            },
            {
                type: 'radio',
                label: '',
                name: 'reinvestir_hpp',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Pretende amortizar o crédito habitação com o valor da sua mais-valia?',
            },
            {
                type: 'radio',
                label: '',
                name: 'amortizar_credito_habitacao',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'É, em termos fiscais, residente em Portugal?',
            },
            {
                type: 'radio',
                label: '',
                name: 'residente_portugal',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Tem declaração fiscal conjunta?',
            },
            {
                type: 'radio',
                label: '',
                name: 'declaracao_fiscal_conjunta',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
            {
                type: 'heading',
                label: 'Qual é o seu Rendimento Anual Coletável para IRS?',
            },
            {
                type: 'number',
                label: 'Valor Bruto',
                name: 'valor_bruto',
                icon: 'currency',
            },
            {
                type: 'heading',
                label: 'Relativamente ao imóvel alienado, beneficiou de apoio não reembolsável concedido pelo Estado ou outras entidades públicas para a aquisição, construção, reconstrução ou realização de obras de conservação de valor superior a 30% do valor patrimonial tributário do imóvel?',
            },
            {
                type: 'radio',
                label: '',
                name: 'apoio_nao_reembolsavel',
                layout: 'horizontal',
                options: [
                    { value: 'sim', label: 'Sim' },
                    { value: 'nao', label: 'Não' },
                ],
            },
        ],
    },
    imi: {
        validation: validations.imi,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/imi',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
                name: 'dados_simulacao',
            },
            {
                type: 'number',
                label: 'Valor Patrimonial Tributário',
                name: 'valor_patrimonial_tributario',
                icon: 'currency',
                defaultValue: 100000,
            },
            {
                type: 'select',
                options: distritos.map(district => ({
                    label: district.name,
                    value: district.id,
                })),
                label: 'Distrito',
                name: 'distrito',
            },
            {
                type: 'select',
                label: 'Concelho',
                name: 'concelho',
                options: [],
                populate: {
                    field: 'distrito',
                    callback: (value) => {
                        const selectedDistrict = distritos.find(district =>
                            district.id === parseInt(value, 10));
                        return selectedDistrict.conselhos.map(conselho => ({
                            label: conselho.name,
                            value: conselho.id,
                        }));
                    },
                },
            },
            {
                type: 'select',
                options: [
                    { value: 'predio_urbano', label: 'Prédio Urbano' },
                    { value: 'predio_rustico', label: 'Prédio Rústico' },
                ],
                label: 'Tipo de Imóvel',
                name: 'tipo_imovel',
            },
            {
                type: 'number',
                label: 'Nº de dependentes',
                name: 'dependentes',
                defaultValue: 0,
            },
        ],
    },
    imt: {
        validation: validations.imt,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/imt',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
                name: 'dados_simulacao',
            },
            {
                type: 'select',
                options: [
                    { value: 'CNT', label: 'Portugal Continental' },
                    { value: 'MAD', label: 'Região Autónoma da Madeira' },
                    { value: 'AZO', label: 'Região Autónoma dos Açores' },
                ],
                label: 'Local do imóvel',
                name: 'localizacao',
                defaultValue: 'CNT',
            },
            {
                type: 'select',
                options: helpers.property_purpose(),
                label: 'Tipo do Imóvel',
                name: 'tipo_imovel',
            },
            {
                type: 'number',
                label: 'Valor do Imóvel',
                name: 'valor_imovel',
                icon: 'currency',
            },
        ],
    },
    fixacao_prestacao: {
        validation: validations.fixacao_prestacao,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/fixacao-prestacao',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
                name: 'dados_simulacao',
            },
            {
                type: 'select',
                options: [
                    { value: 'euribor_3', label: '3 meses' },
                    { value: 'euribor_6', label: '6 meses' },
                    { value: 'euribor_12', label: '12 meses' },
                ],
                label: 'Euribor',
                name: 'euribor',
                defaultValue: 'euribor_3',
            },
            {
                type: 'select',
                options: helpers.generatePastMonths(),
                label: 'Data da última alteração de prestação',
                name: 'ultima_alteracao',
                defaultValue: helpers.generatePastMonths()[0].value,
                tooltip: {
                    title: 'Data da última alteração de prestação',
                    content: 'Indique o mês em que começou a pagar a sua prestação atual',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: helpers.generatePastMonths(),
                label: 'Mês do pedido',
                name: 'mes_pedido',
                tooltip: {
                    title: 'Mês do pedido',
                    content: 'Indique o mês em que fez o pedido para fixar a sua prestação.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Spread',
                name: 'spread',
                icon: 'percentage',
                placeholder: 1.5,
            },
            {
                type: 'number',
                label: 'Valor em dívida',
                name: 'valor_divida',
                icon: 'currency',
                placeholder: '200.000',
            },
            {
                type: 'number',
                label: 'Prestações mensais em falta',
                name: 'prestacoes_falta',
                placeholder: 120,
            },
        ],
    },
    despesas: {
        validation: validations.despesas,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/despesas',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Despesas mensais recorrentes',
                name: 'despesas_mensais',
                collapsible: true,
            },
            {
                type: 'number',
                label: 'Renda ou prestação',
                name: 'renda_prestacao',
                icon: 'currency',
                placeholder: '0,00',
                tooltip: {
                    title: 'Despesas mensais de habitação',
                    content: 'Prestação de Crédito Habitação ou renda.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Eletricidade, água e gás',
                name: 'eletricidade_agua_gas',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Condomínio',
                name: 'condominio',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Supermercado',
                name: 'supermercado',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Transportes',
                name: 'transportes',
                icon: 'currency',
                tooltip: {
                    title: 'Transportes',
                    content: 'Considere todas as despesas que tem com transportes: Combustível, portagens, passe, transportes públicos, entre outros.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Empréstimos e seguros',
                name: 'emprestimos_seguros',
                icon: 'currency',
                tooltip: {
                    title: 'Empréstimos e seguros',
                    content: 'Considere todas as despesas relacionadas com créditos (exemplo: automóvel, pessoal) e Seguros (exemplo: multirriscos, vida, automóvel, saúde)',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Despesas médicas',
                name: 'despesas_medicas',
                icon: 'currency',
                tooltip: {
                    title: 'Despesas médicas',
                    content: 'Considere todas as despesas relacionadas com saúde: consultas, exames, medicamentos, entre outros.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Educação',
                name: 'educacao',
                icon: 'currency',
                tooltip: {
                    title: 'Educação',
                    content: 'Considere despesas coma educação: propinas, manuais e material escolar, atividades extracurriculares, entre outros.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Outras despesas recorrentes',
                name: 'outras_despesas',
                icon: 'currency',
            },
            {
                type: 'title',
                label: 'Despesas mensais não recorrentes',
                name: 'despesas_mensais',
                collapsible: {
                    collapsed: true,
                },
            },
            {
                type: 'number',
                label: 'Restauração',
                name: 'restauracao',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Entretenimento e desporto',
                name: 'entretenimento_desporto',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Férias',
                name: 'ferias',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Cuidados pessoais',
                name: 'cuidados_pessoais',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Outras despesas não recorrentes',
                name: 'outras_despesas_nao_recurrentes',
                icon: 'currency',
            },
            {
                type: 'title',
                label: 'Rendimentos mensais',
                name: 'rendimentos_mensais',
                collapsible: {
                    collapsed: true,
                },
            },
            {
                type: 'number',
                label: 'Salários e Pensões',
                name: 'salarios',
                icon: 'currency',
                tooltip: {
                    title: 'Salários e Pensões',
                    content: 'Salário ou Pensão líquida, após dedução de impostos.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Subsídios',
                name: 'subsidios',
                icon: 'currency',
                tooltip: {
                    title: 'Subsídios',
                    content: 'Subsídio de desemprego, Subsídio de Natal e/ou Férias, Subsídio Parental, Subsídio de Assistência Familar, entre outros.',
                    placement: 'right',
                },
            },
            {
                type: 'number',
                label: 'Bónus e prémios',
                name: 'bonus_premios',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Retorno de Investimentos e Poupanças',
                name: 'retorno_investimento',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Outros rendimentos',
                name: 'outros_rendimentos',
                icon: 'currency',
            },
        ],
    },
    prestacao_amortizacao: {
        validation: validations.prestacao_amortizacao,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/prestacao-amortizacao',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            processType: 4,
            operationType: 2,
        },

        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'number',
                label: 'Capital em dívida',
                name: 'capital_divida',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Taxa de juro (spread+euribor)',
                name: 'taxa_juro',
                icon: 'percentage',
            },
            {
                type: 'number',
                label: 'Prestações mensais em falta',
                name: 'prestacao_falta',
            },
            {
                type: 'number',
                label: 'Valor a amortizar',
                name: 'valor_amortizar',
                icon: 'currency',
            },
        ],
    },
    valor_imovel: {
        validation: validations.valor_imovel,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/valor-imovel',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },

        fields: [
            {
                type: 'title',
                label: 'Dados para a simulação',
            },
            {
                type: 'map',
                label: 'Morada ou código postal',
                name: 'address',
            },
            {
                type: 'select',
                options: [
                    { value: 'apartment', label: 'Apartamento' },
                    { value: 'house', label: 'Moradia' },
                ],
                label: 'Tipo de imóvel',
                name: 'asset_type',
            },
            {
                type: 'select',
                options: [
                    { value: 'new', label: 'Novo' },
                    { value: 'used', label: 'Usado' },
                    { value: 'renovated', label: 'Renovado' },
                    { value: 'inConstruction', label: 'Em construção' },
                    { value: 'forRecovery', label: 'Para recuperação' },
                    { value: 'ruin', label: 'Em ruína' },
                ],
                label: 'Condição',
                name: 'condition',
            },
            {
                type: 'number',
                label: 'Área bruta m2',
                name: 'area',
            },
            {
                type: 'select',
                options: helpers.generateYears(),
                label: 'Ano de construção',
                name: 'construction_year',
                tooltip: {
                    title: '...',
                    content: '...',
                    placement: 'right',
                },
            },
            {
                type: 'select',
                options: [
                    { value: 0, label: 'T0' },
                    { value: 1, label: 'T1' },
                    { value: 2, label: 'T2' },
                    { value: 3, label: 'T3' },
                    { value: 4, label: 'T4' },
                    { value: 5, label: 'T5' },
                    { value: 6, label: 'T6' },
                    { value: 7, label: 'T7' },
                    { value: 8, label: 'T8' },
                    { value: 9, label: 'T9' },
                    { value: 10, label: 'T10' },
                ],
                label: 'Tipologia',
                name: 'number_of_rooms',
            },
            {
                type: 'heading',
                label: 'Características do imóvel',
            },
            {
                type: 'checkbox',
                label: 'Elevador',
                name: 'elevator',
                className: '-mb-4',
            },
            {
                type: 'checkbox',
                label: 'Garagem',
                name: 'closedGarage',
                className: '-mb-4',
            },
            {
                type: 'checkbox',
                label: 'Vidros duplos',
                name: 'doubleWindows',
            },
            {
                type: 'heading',
                label: 'O que pretende fazer com este imóvel?',
            },
            {
                type: 'select',
                options: [
                    { value: 'Estou a pensar vender este imóvel', label: 'Estou a pensar vender este imóvel' },
                    { value: 'Estou a pensar comprar este imóvel', label: 'Estou a pensar comprar este imóvel' },
                    { value: 'Quero apenas avaliar o meu património', label: 'Quero apenas avaliar o meu património' },
                ],
                label: '',
                name: 'property_intention',
            },
            {
                type: 'heading',
                label: 'Quando está a pensar fazê-lo?',
            },
            {
                type: 'select',
                options: [
                    { value: 'Nos próximos 3 meses', label: 'Nos próximos 3 meses' },
                    { value: 'Nos próximos 6 meses', label: 'Nos próximos 6 meses' },
                    { value: 'Nos próximos 12 meses', label: 'Nos próximos 12 meses' },
                    { value: 'Não Aplicável', label: 'Não Aplicável' },
                ],
                label: '',
                name: 'timing_plan',
            },
        ],
    },
    mac: {
        validation: validations.mac,
        api: {
            url: window.location.origin + '/wp-json/tools/v1/mac',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        },
        fields: [
            {
                type: 'title',
                label: 'Dados relativos ao agregado familiar',
            },
            {
                type: 'number',
                label: 'Idade do titular mais velho',
                name: 'customerAge',
            },
            {
                type: 'number',
                label: 'Capitais próprios disponíveis',
                name: 'equityDownAmount',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Rendimento Mensal Líquido',
                name: 'monthlyNetIncome',
                icon: 'currency',
            },
            {
                type: 'number',
                label: 'Despesas mensais com outros créditos',
                name: 'monthlyLoanExpenses',
                icon: 'currency',
            },
            {
                type: 'title',
                label: 'Informação sobre o imóvel',
            },
            {
                type: 'select',
                options: [
                    { value: 'PRIMARY_PROPERTY_RESIDENCE', label: 'Habitação própria permanente' },
                    { value: 'SECONDARY_PROPERTY_RESIDENCE', label: 'Habitação secundária ou arrendamento' },
                ],
                label: 'Finalidade do imóvel',
                name: 'propertyPurpose',
            },
            {
                type: 'select',
                options: [
                    { value: 'CONTINENTAL_PORTUGAL', label: 'Portugal Continental' },
                    { value: 'AUTONOMOUS_REGIONS', label: 'Regiões Autónomas' },
                ],
                label: 'Localização',
                name: 'propertyLocation',
                defaultValue: 'CONTINENTAL_PORTUGAL',
                tooltip: {
                    title: 'Localização',
                    content: 'Localização...',
                    placement: 'right',
                },
            },
            {
                type: 'title',
                label: 'Taxa de juro a contratar',
            },
            {
                type: 'select',
                options: [
                    { value: 'FIXED', label: 'Fixa' },
                    { value: 'MIXED', label: 'Mista' },
                    { value: 'VARIABLE', label: 'Variável' },
                ],
                label: 'Tipo de taxa de juro',
                name: 'rateType',
                defaultValue: 'MIXED',
            },
        ],
    },

};
